import { formatDocumentAddress } from "../../../app/newLayout/page/utils/tableDataElements";
import { STOCK_ZONE_TYPE_PRESETS } from "../../../constant/data";
import {
  useGetAccountTypeQuery,
  useGetChartsAccountSelectionQuery,
  useGetPaymentTermSelectionQuery,
  useGetTrackingCategorySelectionQuery,
} from "../../../store/apiSlice/accountApiSlice";
import {
  useGetCountriesQuery,
  useGetSubdivisionsQuery,
} from "../../../store/apiSlice/configApiSlice";
import { useGetCurrencyQuery } from "../../../store/apiSlice/currencyApiSlice";
import {
  useGetCustomerCitiesSelectionQuery,
  useGetCustomerPostcodesSelectionQuery,
  useGetCustomerSegmentSelectionQuery,
  useGetCustomersSelectionQuery,
  useGetCustomerStatesSelectionQuery,
  useGetCustomerTagsSelectionQuery,
} from "../../../store/apiSlice/customerApiSlice";
import {
  useGetXeroAccountsQuery,
  useGetXeroTaxRatesQuery,
} from "../../../store/apiSlice/integrationApiSlice";
import {
  useGetAllocateCostSourcesQuery,
  useGetBillChargeTypesSelectionQuery,
} from "../../../store/apiSlice/invoiceApiSlice";
import { useGetTransferOrdersSelectionQuery } from "../../../store/apiSlice/orderApiSlice";
import { useGetPortalAddressesQuery } from "../../../store/apiSlice/portalCartApiSlice";
import {
  useGetPricelistFormulasSelectionQuery,
  useGetPriceListsSelectionQuery,
} from "../../../store/apiSlice/pricingApiSlice";
import {
  useGetProductCategoriesSelectionQuery,
  useGetProductsByWarehouseQuery,
  useGetProductsSelectionQuery,
  useGetProductTagsSelectionQuery,
} from "../../../store/apiSlice/productApiSlice";
import {
  useGetBomsSelectionQuery,
  useGetPeopleRolesQuery,
  useGetPeopleSelectionQuery,
} from "../../../store/apiSlice/productionApiSlice";
import { useGetPurchaseOrdersSelectionQuery } from "../../../store/apiSlice/purchaseOrderApiSlice";
import { useGetTransactionReasonsSelectionQuery } from "../../../store/apiSlice/reportApiSlice";
import {
  useGetSalesOrderSelectionQuery,
  useGetSalesRepSelectionQuery,
} from "../../../store/apiSlice/salesApiSlice";
import {
  useGetEquipmentCategoriesQuery,
  useGetEquipmentsSelectionQuery,
  useGetEquipmentTypesSelectionQuery,
  useGetFreightForwardersQuery,
  useGetShipmentLegCarriersQuery,
} from "../../../store/apiSlice/shipmentApiSlice";
import {
  useGetSuppliersSelectionQuery,
  useGetWarehouseSelectionQuery,
} from "../../../store/apiSlice/supplierApiSlice";
import {
  useGetProductTaxClassificationSelectionQuery,
  useGetTaxCategorySelectionQuery,
  useGetTaxJurisdictionSelectionQuery,
  useGetTaxSelectionQuery,
} from "../../../store/apiSlice/taxApiSlice";
import { useGetUnitOfMeasureSelectionQuery } from "../../../store/apiSlice/unitOfMeasureApiSlice";
import { useGetUsersForCollabQuery } from "../../../store/apiSlice/userApiSlice";
import {
  useGetSitesSelectionQuery,
  useGetStockLocationsSelectionQuery,
  useGetStockZonesSelectionQuery,
  useGetWarehouseCostingSelectionQuery,
  useGetWarehouseInventoryQuery,
  useGetWarehouseLandedQuery,
  useGetWarehouseStockZoneTypesQuery,
  useGetWorkCentersSelectionQuery,
  useGetWorkCenterTypesQuery,
} from "../../../store/apiSlice/warehouseApiSlice";
import { useGetAllTimeZones } from "./timezone";

export const MODULES_SELECTION_DATA_ENDPOINTS = {
  freightForwarders: {
    func: useGetFreightForwardersQuery,
    prepare: null,
  },
  productCategories: {
    func: useGetProductCategoriesSelectionQuery,
    prepare: null,
  },
  productTags: {
    func: useGetProductTagsSelectionQuery,
    prepare: null,
  },
  products: {
    func: useGetProductsSelectionQuery,
    prepare: null,
  },
  productsByWarehouse: {
    func: useGetProductsByWarehouseQuery,
    prepare: null,
  },
  supplier: {
    func: useGetSuppliersSelectionQuery,
    prepare: null,
  },
  warehouse: {
    func: useGetWarehouseSelectionQuery,
    prepare: null,
  },
  site: {
    func: useGetSitesSelectionQuery,
    prepare: sites =>
      (Array.isArray(sites) ? sites : []).map(item => ({
        label: item.code ? `${item.name} (${item.code})` : item.name,
        value: item.id,
      })),
  },
  workCenter: {
    func: useGetWorkCentersSelectionQuery,
    prepare: workCenters =>
      (Array.isArray(workCenters) ? workCenters : []).map(item => ({
        label: item.code ? `${item.name} (${item.code})` : item.name,
        value: item.id,
      })),
  },
  workCenterType: {
    func: useGetWorkCenterTypesQuery,
  },
  people: {
    func: useGetPeopleSelectionQuery,
    prepare: people => people.map(item => ({ value: item.id, label: item.full_name })),
  },
  peopleRole: {
    func: useGetPeopleRolesQuery,
    prepare: roles =>
      roles.map(role => {
        const name = role.name || role.id || "";
        // Preset keys are snake_case; title-case those only. Custom roles stay
        // human-readable text from the API and must not be lowercased.
        const label = /^[a-z0-9_]+$/.test(name)
          ? name
              .split("_")
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ")
          : name;
        return { label, value: role.id };
      }),
  },
  currency: {
    func: useGetCurrencyQuery,
    prepare: null,
  },
  warehouseCosting: {
    func: useGetWarehouseCostingSelectionQuery,
    prepare: warehouseCostings => {
      return warehouseCostings.map(item => ({
        label: `${item.product?.number}  ${item.from_warehouse?.code ? "- " + item.from_warehouse.code : ""}  ${item.supplier?.code ? "- " + item.supplier.code : ""}  ${item.to_warehouse?.code ? "- " + item.to_warehouse.code : ""}`,
        value: item.id,
      }));
    },
  },
  iam: {
    func: useGetWarehouseInventoryQuery,
    prepare: null,
  },
  warehouseLandedCostType: {
    func: useGetWarehouseLandedQuery,
    prepare: null,
  },
  stockLocation: {
    func: useGetStockLocationsSelectionQuery,
    prepare: null,
  },
  stockZone: {
    func: useGetStockZonesSelectionQuery,
    prepare: stockZones => {
      return stockZones.map(item => ({
        label: item.name,
        value: item.id,
      }));
    },
  },
  reason: {
    func: useGetTransactionReasonsSelectionQuery,
    prepare: reasons => reasons.map(reason => ({ value: reason.id, label: reason?.reason })),
  },
  bomsSelection: {
    func: useGetBomsSelectionQuery,
    prepare: null,
  },

  accountType: {
    func: useGetAccountTypeQuery,
    prepare: null,
  },
  billChargeType: {
    func: useGetBillChargeTypesSelectionQuery,
    prepare: chargeTypes => {
      const list = Array.isArray(chargeTypes)
        ? chargeTypes
        : Array.isArray(chargeTypes?.results)
          ? chargeTypes.results
          : [];
      return list.map(item => ({
        label: item.name,
        value: item.id,
        item,
      }));
    },
  },
  jurisdiction: {
    func: useGetTaxJurisdictionSelectionQuery,
  },
  paymentTerm: {
    func: useGetPaymentTermSelectionQuery,
    prepare: null,
  },
  xeroTaxRate: {
    func: useGetXeroTaxRatesQuery,
    prepare: taxRates =>
      taxRates.map(taxRate => ({
        label: taxRate.name + " " + taxRate.effective_rate + "% " + taxRate.tax_type,
        value: taxRate.tax_type,
      })),
  },
  xeroAccount: {
    func: useGetXeroAccountsQuery,
    prepare: accounts =>
      accounts.map(acc => ({
        label: acc.code + ": " + acc.name,
        value: acc.code,
      })),
  },

  chartAccount: {
    func: useGetChartsAccountSelectionQuery,
    prepare: accounts => {
      const list = Array.isArray(accounts) ? accounts : accounts?.results || [];
      return [...list]
        .map(acc => ({
          label: acc.code ? `${acc.code} - ${acc.name}` : acc.name,
          value: acc.id,
        }))
        .sort((a, b) =>
          (a.label || "").localeCompare(b.label || "", undefined, { sensitivity: "base" }),
        );
    },
  },
  /** Charts of account with code prefix for Shopify revenue account. */
  chartAccountCoded: {
    func: useGetChartsAccountSelectionQuery,
    prepare: accounts => {
      const list = Array.isArray(accounts) ? accounts : accounts?.results || [];
      return list.map(acc => ({
        label: acc.code ? `${acc.code} - ${acc.name}` : acc.name,
        value: acc.id,
      }));
    },
  },
  taxRate: {
    func: useGetTaxSelectionQuery,
    prepare: taxes =>
      taxes.map(tax => ({
        label: `${tax.name}${tax.rate !== undefined && tax.rate !== null ? ` - ${tax.rate}%` : ""}`,
        value: tax.id,
      })),
  },
  purchaseOrder: {
    func: useGetPurchaseOrdersSelectionQuery,
    prepare: null,
  },
  salesOrder: {
    func: useGetSalesOrderSelectionQuery,
    prepare: null,
  },
  transferOrder: {
    func: useGetTransferOrdersSelectionQuery,
    prepare: null,
  },
  allocateShipment: {
    func: useGetAllocateCostSourcesQuery,
  },
  trackingCategory: {
    func: useGetTrackingCategorySelectionQuery,
    prepare: null,
  },
  timezone: {
    func: useGetAllTimeZones,
    prepare: null,
  },
  countries: {
    func: useGetCountriesQuery,
    prepare: null,
  },
  subdivisions: {
    func: useGetSubdivisionsQuery,
    prepare: null,
  },
  taxCategory: {
    func: useGetTaxCategorySelectionQuery,
    prepare: null,
  },
  users: {
    func: useGetUsersForCollabQuery,
    prepare: users =>
      users.map(user => ({
        label: user.full_name,
        value: user.id,
      })),
  },
  productTaxClassification: {
    func: useGetProductTaxClassificationSelectionQuery,
    prepare: null,
  },
  customerTag: {
    func: useGetCustomerTagsSelectionQuery,
    prepare: null,
  },
  customerSegment: {
    func: useGetCustomerSegmentSelectionQuery,
    prepare: null,
  },
  customer: {
    func: useGetCustomersSelectionQuery,
    prepare: customers =>
      customers.map(c => ({
        label: `${c.display_name} (${c.customer_code})`,
        value: c.id,
      })),
  },
  customerStates: {
    func: useGetCustomerStatesSelectionQuery,
    prepare: null,
  },
  customerCities: {
    func: useGetCustomerCitiesSelectionQuery,
    prepare: null,
  },
  customerPostcodes: {
    func: useGetCustomerPostcodesSelectionQuery,
    prepare: null,
  },
  unitOfMeasure: {
    func: useGetUnitOfMeasureSelectionQuery,
    prepare: null,
  },
  priceListFormula: {
    func: useGetPricelistFormulasSelectionQuery,
    prepare: formulas => [
      { value: null, label: "No Formula Configured" },
      ...formulas.map(f => {
        const logicVal = parseFloat(f.logic_value || 0);
        const logicName = f.logic?.name?.replace(" %", "")?.replace(" Amount", "");
        const suffix = f.logic?.id?.includes("_pct") ? "%" : "";
        const roundTo = parseFloat(f.round_to || 0);
        const extraFee = parseFloat(f.extra_fee || 0);
        const feeDir = f.fee_direction?.id === "decrease" ? "-" : "+";

        let label = `${logicVal}${suffix} ${logicName}`;
        if (roundTo) label += `, round to ${roundTo}`;
        if (extraFee) label += `, ${feeDir} $${extraFee.toFixed(2)}`;

        return {
          value: f.id,
          label,
        };
      }),
    ],
  },
  pricelist: {
    func: useGetPriceListsSelectionQuery,
    prepare: null,
  },
  salesRep: {
    func: useGetSalesRepSelectionQuery,
    // Selection payload is `{ id, is_active, user: { full_name, ... } }`.
    prepare: reps =>
      (Array.isArray(reps) ? reps : reps?.results || []).map(rep => ({
        label:
          rep.user?.full_name ||
          rep.full_name ||
          [rep.user?.first_name, rep.user?.last_name].filter(Boolean).join(" ") ||
          rep.name ||
          `Sales Rep #${rep.id}`,
        value: rep.id,
      })),
  },
  equipmentCategory: {
    func: useGetEquipmentCategoriesQuery,
    prepare: null,
  },
  equipmentType: {
    func: useGetEquipmentTypesSelectionQuery,
    prepare: null,
  },
  equipment: {
    func: useGetEquipmentsSelectionQuery,
    prepare: null,
  },
  carrier: {
    func: useGetShipmentLegCarriersQuery,
    prepare: null,
  },
  stockZoneType: {
    func: useGetWarehouseStockZoneTypesQuery,
    prepare: list => {
      const labelById = Object.fromEntries(
        STOCK_ZONE_TYPE_PRESETS.map(item => [item.id, item.name]),
      );
      return list.map(item => ({
        label: labelById[item.id] || item.name || item.id,
        value: item.id,
      }));
    },
  },
  portalAddresses: {
    func: useGetPortalAddressesQuery,
    prepare: addresses =>
      addresses.map(addr => ({
        label: formatDocumentAddress(addr),
        value: addr.id,
      })),
  },
};
